import React from 'react';

export const User = () => {
	return (
		<svg width="18" height="19" viewBox="0 0 18 19" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.00012 0C6.2387 0 4.00012 2.23858 4.00012 5C4.00012 7.76142 6.2387 10 9.00012 10C11.7615 10 14.0001 7.76142 14.0001 5C14.0001 2.23858 11.7615 0 9.00012 0ZM6.00012 5C6.00012 3.34315 7.34327 2 9.00012 2C10.657 2 12.0001 3.34315 12.0001 5C12.0001 6.65685 10.657 8 9.00012 8C7.34327 8 6.00012 6.65685 6.00012 5Z"
				fill="#64778F"
			/>
			<path
				d="M9.00014 12C7.08066 12 5.19395 12.4738 3.63126 13.3732C2.06914 14.2722 0.881361 15.5702 0.331028 17.1106C0.145218 17.6307 0.416205 18.203 0.936294 18.3888C1.45638 18.5746 2.02863 18.3036 2.21444 17.7835C2.57571 16.7723 3.39665 15.8157 4.62884 15.1066C5.86045 14.3978 7.39747 14 9.00014 14C10.6028 14 12.1398 14.3978 13.3714 15.1066C14.6036 15.8157 15.4246 16.7723 15.7858 17.7835C15.9717 18.3036 16.5439 18.5746 17.064 18.3888C17.5841 18.203 17.8551 17.6307 17.6693 17.1106C17.1189 15.5702 15.9311 14.2722 14.369 13.3732C12.8063 12.4738 10.9196 12 9.00014 12Z"
				fill="#64778F"
			/>
		</svg>
	);
};
